const OENotification = {
    viewOpenStateChanged: 'view_open_state_changed',
    viewPresentableStateChanged: 'view_presentable_state_changed',
    colorModelChanged: 'color_model_changed',
    mediaCenterDirectPlayChanged: 'media_center_direct_play_changed'
};

export default OENotification;